import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { validateEnv } from "./config/validateEnv";

// Validate environment variables before starting the app
try {
  validateEnv();
} catch (error) {
  console.error(error.message);
  // Show error to user if in development
  if (process.env.NODE_ENV === "development") {
    document.body.innerHTML = `
      <div style="
        font-family: monospace;
        padding: 40px;
        background: #1a1a1a;
        color: #ff6b6b;
        min-height: 100vh;
      ">
        <pre style="white-space: pre-wrap;">${error.message}</pre>
      </div>
    `;
  }
  throw error;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
